import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
const API = window.location.origin + '/api';
const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [otpStep, setOtpStep] = useState(false);
  const [dealerId, setDealerId] = useState<number | null>(null);
  const [otpCode, setOtpCode] = useState('');
  const navigate = useNavigate();
  const handleLogin = async () => {
    setLoading(true); setError('');
    try {
      const res = await axios.post(`${API}/auth/login`, form);
      if (res.data.requireOtp) { setDealerId(res.data.dealerId); setOtpStep(true); }
      else { localStorage.setItem('token', res.data.token); localStorage.setItem('dealer', JSON.stringify(res.data.dealer)); navigate('/home'); }
    } catch (err: any) { setError(err.response?.data?.error || 'Login failed'); }
    finally { setLoading(false); }
  };
  const handleVerifyOtp = async () => {
    setLoading(true); setError('');
    try {
      const res = await axios.post(`${API}/auth/verify-otp`, { dealerId, otp: otpCode });
      localStorage.setItem('token', res.data.token); localStorage.setItem('dealer', JSON.stringify(res.data.dealer)); navigate('/home');
    } catch (err: any) { setError(err.response?.data?.error || 'Invalid code'); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-black text-2xl" style={{ backgroundColor: '#B8860B' }}>X</div>
          <div><p className="font-bold text-gray-900 text-lg">BULLIONX</p><p className="text-gray-400 text-xs">Inter-Dealer Platform</p></div>
        </div>
        {error && <p className="text-red-500 text-xs mb-4 text-center">{error}</p>}
        {otpStep ? (
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2 text-center">Check your email</h2>
            <p className="text-gray-500 text-sm mb-6 text-center">We sent a 6-digit code to <strong>{form.email}</strong></p>
            <input type="text" value={otpCode} onChange={e => setOtpCode(e.target.value)} className="w-full border border-gray-200 rounded-lg px-4 py-4 text-center text-3xl font-bold tracking-widest focus:outline-none mb-4" placeholder="000000" maxLength={6} />
            <button onClick={handleVerifyOtp} disabled={loading || otpCode.length !== 6} className="w-full py-3 rounded-lg text-white text-sm font-semibold disabled:opacity-50 mb-3" style={{ backgroundColor: '#1a1a2e' }}>{loading ? '...' : 'Verify Code'}</button>
            <button onClick={() => { setOtpStep(false); setOtpCode(''); setError(''); }} className="w-full text-xs text-gray-400 hover:text-gray-600 text-center">← Back to login</button>
          </div>
        ) : (
          <div>
            <div className="mb-4"><label className="text-gray-500 text-xs mb-1 block">Email</label><input type="email" placeholder="dealer@company.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} onKeyDown={e => e.key === 'Enter' && handleLogin()} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-gray-400" /></div>
            <div className="mb-6"><label className="text-gray-500 text-xs mb-1 block">Password</label><input type="password" placeholder="········" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} onKeyDown={e => e.key === 'Enter' && handleLogin()} className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-gray-400" /></div>
            <button onClick={handleLogin} disabled={loading} className="w-full py-3 rounded-lg text-white text-sm font-semibold disabled:opacity-50" style={{ backgroundColor: '#1a1a2e' }}>{loading ? 'Logging in...' : 'Login'}</button>
            <p className="text-center mt-4"><Link to="/forgot-password" className="text-xs" style={{ color: '#B8860B' }}>Forgot password?</Link></p>
            <p className="text-gray-500 text-sm mt-3 text-center">No account?{' '}<Link to="/register" className="text-blue-500 hover:text-blue-600">Register</Link></p>
          </div>
        )}
      </div>
    </div>
  );
};
export default Login;
